import { Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  Filters,
  FnCaricamentoDati,
  SortBy,
} from 'src/app/components/lista-tabellare/classes/lista-tabellare-data-source';
import {
  BottoniListaEvent,
  Colonna,
  Filtri,
  ListaTabellareComponent,
} from 'src/app/components/lista-tabellare/lista-tabellare.component';
import { SpinnerOverlayComponent } from 'src/app/components/spinner-overlay/spinner-overlay.component';
import { PianoService } from 'src/app/services/piano/piano.service';
import { UtilityService } from 'src/app/services/utility/utility.service';
import { DialogCreaObiettivoAziendaliComponent } from './dialog/dialog-crea-obiettivo-aziendali/dialog-crea-obiettivo-aziendali.component';

@Component({
  selector: 'app-cfg-obiettivi-aziendali',
  templateUrl: './cfg-obiettivi-aziendali.component.html',
  styleUrls: ['./cfg-obiettivi-aziendali.component.scss'],
  standalone: false,
})
export class CfgObiettiviAziendaliComponent {
  @ViewChild('tabella') tabella!: ListaTabellareComponent;
  @ViewChild(SpinnerOverlayComponent) spinnerOver!: SpinnerOverlayComponent;

  public filtri: Filtri[] = [
    {
      titolo: 'Descrizione',
      forControlName: 'descrizione',
      input: 'text',
    },
  ];

  public colonne: { [key: string]: Colonna } = {
    titolo: {
      title: 'Titolo',
      value: 'descrizione',
      sortable: true,
    },
    note: {
      title: 'Descrizione',
      value: 'note',
      sortable: true,
    },

    modifica: {
      type: 'button',
      buttonIcon: 'edit',
      title: 'Modifica',
      buttonId: 'modifica',
      buttonMostraSempre: true,
    },
    elimina: {
      type: 'button',
      buttonIcon: 'delete',
      title: 'Elimina',
      buttonId: 'elimina',
    },
  };
  constructor(
    public dialog: MatDialog,
    private readonly utilityService: UtilityService,
    private readonly pianoService: PianoService,
  ) {}

  public fnCaricamentoDati: FnCaricamentoDati = (
    page: number,
    pageSize: number,
    ricerca?: string,
    filters?: Filters[],
    sortBy?: SortBy[],
  ) => {
    sortBy ??= [
      {
        chiave: 'descrizione',
        sort: 'asc',
      },
    ];

    return this.pianoService.getObiettiviAziendali(page, pageSize, ricerca, filters, sortBy);
  };

  public bottoniListaClick(event: BottoniListaEvent) {
    switch (event.id) {
      case 'modifica':
        this.creaNuovo(event.data);
        break;
      case 'elimina':
        this.elimina(event.data.id);
        break;
      default:
        console.warn('ATTENZIONE: bottone ' + event.id + ' non riconosciuto');
    }
  }

  creaNuovo(obiettivoPiano?: any) {
    const dialogCreaObiettivoPiano = this.dialog.open(DialogCreaObiettivoAziendaliComponent, {
      data: {
        obiettivoAziendalePiano: obiettivoPiano,
      },
      panelClass: ['dialog-container'],
      disableClose: false,
      width: '70%',
      maxHeight: '95%',
      autoFocus: false,
    });

    dialogCreaObiettivoPiano.afterClosed().subscribe((result) => {
      this.tabella.caricaDati();
    });
  }

  elimina(idRiga: string) {
    this.utilityService.openDialog({
      descrizione: "Confermi di eliminare l'obiettivo aziendale",
      bottoni: [
        {
          nome_btn: 'NO',
          background_color: 'var(--mat-color-accent)',
        },
        {
          nome_btn: 'SI',
          background_color: 'var(--mat-color-primary)',
          handler: () => {
            this.spinnerOver.show();
            this.pianoService.deleteObiettiviAziendaliPiano(idRiga).subscribe({
              next: () => {
                this.tabella.caricaDati();
                this.spinnerOver.hide();
              },
              error: (err: any) => {
                this.spinnerOver.hide();
                this.utilityService.openDialog({
                  titolo: 'Attenzione',
                  descrizione: err.error.message,
                  bottoni: [
                    {
                      nome_btn: 'Chiudi',
                      handler: () => {
                        this.tabella.caricaDati();
                      },
                    },
                  ],
                });
              },
            });
          },
        },
      ],
    });
  }
}
